import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Button,
  Dropdown,
  Checkbox,
  FormGroup,
  FormField,
  Icon,
  Input
} from 'semantic-ui-react'

const CardDrugOrderQueueUX = (props: any) => {
    return(
      <div
        id="CardDrugOrderQueue"
        style={{ width: "100%",padding: "5px" }}>
        <div
          id="CardDrugOrderQueueUX-div-9"
          style={{display: "flex", padding: "5px", margin: "0.5rem 0 0.75rem", justifyContent: "space-between", alignItems: "center",}}>

          <div
            id="CardDrugOrderQueueUX-div-10"
            style={{display: "flex", alignItems: "center"}}>
            {}
            <div
              id="CardDrugOrderQueueUX-div-155"
              style={{ fontSize: "1.5rem", fontWeight: "bold",  marginTop: "-2px"}}>
              {props.isVerbal ? "รายการรับคำสั่งแพทย์" : "รายการใบยา"}
            </div>
            <label
              id="CardDrugOrderQueueUX-label-156"
              style={{margin: "0 1rem 0 2rem"}}>
              {props.languageUX === "en" ? "Barcode scan" : "สแกนบาร์โค้ด"}
            </label>
            <Input
              id="CardDrugOrderQueueUX-Input-157"
              loading={props.barcodeLoading}
              onChange={props.onChangeBarcode}
              onKeyDown={props.onKeyDownBarcode}
              placeholder="Prescription, Label"
              size="small"
              style={{width: "12rem"}}
              value={props.barcodeScan || ""}>
            </Input>
          </div>
          <div
            id="CardDrugOrderQueueUX-div-152"
            style={{ display: "flex" }}>

            <div
              id="CardDrugOrderQueueUX-div-153"
              style={{ display: props.showDrugOrderPendingList ? "flex" : "none" }}>
              {props.refillPlaned}
            </div>
            <div
              id="CardDrugOrderQueueUX-div-154"
              style={{ marginLeft: "20px" ,display: props.hidePanel ? "none" : ""}}>
              {props.countdownTimer}
            </div>
          </div>
        </div>
        <div
          className="ui form"
          id="CardDrugOrderQueueUX-div-44"
          style={{display: props.hidePanel ? "none" : ""}}>

          <FormGroup
            id="CardDrugOrderQueueUX-FormGroup-45">
            <FormField
              className=" --override-disabled --grey"
              id="CardDrugOrderQueueUX-FormField-48"
              width={3}>
              <FormField
                id="CardDrugOrderQueueUX-FormField-148"
                style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <label
                  id="CardDrugOrderQueueUX-label-149">
                  {props.languageUX === "en" ? "Patient" : "ผู้ป่วย"}
                </label>
                <div
                  id="CardDrugOrderQueueUX-div-150">
                  {props.clearFilterPatient}
                </div>
              </FormField>
              <div
                id="CardDrugOrderQueueUX-div-53"
                style={{width: "100%"}}>
                {props.patientSearch}
              </div>
            </FormField>
            <FormField
              id="CardDrugOrderQueueUX-FormField-49">
              <label
                id="CardDrugOrderQueueUX-label-122">
                {"\u00a0"}
              </label>
              <Checkbox
                checked={props.checkedOPD}
                id="CardDrugOrderQueueUX-Checkbox-54"
                label={props.languageUX === "en" ? "OPD" : "ผู้ป่วยนอก"}
                onChange={props.changeSetDrugOrderCheck("checkedOPD")}
                style={{height: "100%", display: "flex", alignItems: "center", marginTop: "-0.75rem"}}>
              </Checkbox>
            </FormField>
            <FormField
              id="CardDrugOrderQueueUX-FormField-50">
              <label
                id="CardDrugOrderQueueUX-label-123">
                {"\u00a0"}
              </label>
              <Checkbox
                checked={props.checkedIPD}
                id="CardDrugOrderQueueUX-Checkbox-55"
                label={props.languageUX === "en" ? "IPD" : "ผู้ป่วยใน"}
                onChange={props.changeSetDrugOrderCheck("checkedIPD")}
                style={{height: "100%", display: "flex", alignItems: "center", marginTop: "-0.75rem"}}>
              </Checkbox>
            </FormField>
            <FormField
              id="CardDrugOrderQueueUX-FormField-89"
              style={{ minWidth: "max-content"}}>
              <label
                id="CardDrugOrderQueueUX-label-124">
                {"\u00a0"}
              </label>
              <Checkbox
                checked={props.checkedContinue}
                id="CardDrugOrderQueueUX-Checkbox-90"
                label={props.languageUX === "en" ? "Continue for Day dose" : "Continue for Day dose"}
                onChange={props.changeSetDrugOrderCheck("checkedContinue")}
                style={{height: "100%", display: "flex", alignItems: "center", marginTop: "-0.75rem", minWidth: "max-content"}}>
              </Checkbox>
            </FormField>
            <FormField
              id="CardDrugOrderQueueUX-FormField-95"
              width={3}>
              <label
                id="CardDrugOrderQueueUX-label-125">
                {props.languageUX === "en" ? "Division/Ward" : "แผนก/หอผู้ป่วย"}
              </label>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardDrugOrderQueueUX-Dropdown-96"
                onChange={props.changeSetDrugOrder("selectedDivision")}
                options={props.divisionOptions}
                search={true}
                selection={true}
                style={{minWidth:"100%", width: 0}}
                value={props.selectedDivision}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardDrugOrderQueueUX-FormField-62"
              width={3}>
              <label
                id="CardDrugOrderQueueUX-label-138">
                {props.languageUX === "en" ? "Created date" : "วันที่สร้าง"}
              </label>
              <div
                id="CardDrugOrderQueueUX-div-69"
                style={{minWidth:"100%", width: 0}}>
                {props.StartDate}
              </div>
            </FormField>
            <FormField
              id="CardDrugOrderQueueUX-FormField-63">
              <label
                id="CardDrugOrderQueueUX-label-126">
                {"\u00a0"}
              </label>
              <label
                id="CardDrugOrderQueueUX-label-66"
                style={{height: "100%", display: "flex", alignItems: "center", marginTop: "-0.75rem"}}>
                {props.languageUX === "en" ? "to" : "ถึง"}
              </label>
            </FormField>
            <FormField
              id="CardDrugOrderQueueUX-FormField-67"
              width={3}>
              <label
                id="CardDrugOrderQueueUX-label-127">
                {"\u00a0"}
              </label>
              <div
                id="CardDrugOrderQueueUX-div-70"
                style={{minWidth:"100%", width: 0}}>
                {props.EndDate}
              </div>
            </FormField>
            <FormField
              id="CardDrugOrderQueueUX-FormField-119"
              width="3">
              <label
                id="CardDrugOrderQueueUX-label-128">
                Approve order
              </label>
              <Dropdown
                fluid={true}
                id="CardDrugOrderQueueUX-Dropdown-120"
                onChange={props.changeSetDrugOrder("selectedApprove")}
                options={props.approveOption}
                search={true}
                selection={true}
                style={{minWidth:"100%", width: 0}}
                value={props.selectedApprove}>
              </Dropdown>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardDrugOrderQueueUX-FormGroup-46">
            <FormField
              id="CardDrugOrderQueueUX-FormField-92"
              width={2}>
              <label
                id="CardDrugOrderQueueUX-label-129">
                {props.languageUX === "en" ? "Location" : "ที่ตั้ง"}
              </label>
              <Dropdown
                fluid={true}
                id="CardDrugOrderQueueUX-Dropdown-94"
                onChange={props.changeSetDrugOrder("selectedLocation")}
                options={props.divisionTypeDrugOptions || []}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.selectedLocation}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardDrugOrderQueueUX-FormField-81"
              width={props.hideSort ? 6: 5}>
              <div
                id="CardDrugOrderQueueUX-div-130"
                style={{display:"flex", marginBottom: ".28571429rem"}}>

                <label
                  id="CardDrugOrderQueueUX-label-131"
                  style={{fontWeight: 700, color: "rgba(0,0,0,.87)", fontSize: ".92857143em"}}>
                  {props.languageUX === "en" ? "Order Status" : "สถานะคำสั่ง"}
                </label>
                <div
                  id="CardDrugOrderQueueUX-div-132"
                  style={{marginLeft: "0.5rem"}}>

                  <Icon
                    id="CardDrugOrderQueueUX-Icon-133"
                    link={true}
                    name="undo"
                    onClick={props.onResetFilter("selectedDrugOrderStatus")}>
                  </Icon>
                </div>
              </div>
              <div
                id="cb-medOrderStatus"
                style={{width: "100%"}}>
                {props.OrderStatus}
              </div>
            </FormField>
            <FormField
              id="CardDrugOrderQueueUX-FormField-87"
              width={props.hideSort ? 8 : 7}>
              <div
                id="CardDrugOrderQueueUX-div-134"
                style={{display:"flex", marginBottom: ".28571429rem"}}>

                <label
                  id="CardDrugOrderQueueUX-label-135"
                  style={{fontWeight: 700, color: "rgba(0,0,0,.87)", fontSize: ".92857143em"}}>
                  {props.languageUX === "en" ? "Order Type" : "ประเภทคำสั่ง"}
                </label>
                <div
                  id="CardDrugOrderQueueUX-div-136"
                  style={{marginLeft: "0.5rem"}}>

                  <Icon
                    id="CardDrugOrderQueueUX-Icon-137"
                    link={true}
                    name="undo"
                    onClick={props.onResetFilter("selectedDrugOrderType")}>
                  </Icon>
                </div>
              </div>
              <div
                id="cb-medOrderType"
                style={{width: "100%"}}>
                {props.OrderType}
              </div>
            </FormField>
            <FormField
              id="CardDrugOrderQueueUX-FormField-97"
              width={1}>
              <label
                id="CardDrugOrderQueueUX-label-139">
                {"\u00a0"}
              </label>
              <div
                id="CardDrugOrderQueueUX-div-141"
                style={{marginTop: "6px"}}>
                {props.ButtonSearch}
              </div>
            </FormField>
            <FormField
              id="CardDrugOrderQueueUX-FormField-143"
              style={{ display: props.hideSort ? "none" : "" }}>
              <label
                id="CardDrugOrderQueueUX-label-147">
                {"\u00a0"}
              </label>
              <div
                id="CardDrugOrderQueueUX-div-151"
                style={{width: "100%", marginTop: "0.45rem", fontSize: "0.95rem"}}>
                {props.dropdownSort}
              </div>
            </FormField>
          </FormGroup>
        </div>
        <div
          id="CardDrugOrderQueueUX-div-15"
          style={{display: props.hidePanel ? "none" : "none", alignItems: "center"}}>

          <label
            id="CardDrugOrderQueueUX-label-32"
            style={{marginRight: "10px", width: "80px",textAlign: "right"}}>
            {props.languageUX === "en" ? "Patient" : "ผู้ป่วย"}
          </label>
          <div
            id="CardDrugOrderQueueUX-div-16"
            style={{marginRight: "5px", width: "230px"}}>
            {props.patientSearch}
          </div>
          <div
            id="CardDrugOrderQueueUX-div-17"
            style={{display: "flex", alignItems: "center", marginRight: "10px"}}>

            <div
              id="CardDrugOrderQueueUX-div-18"
              style={{marginRight: "5px", width: "100px",textAlign: "right"}}>
              {props.languageUX === "en" ? "Division/Ward" : "แผนก/หอผู้ป่วย"}
            </div>
            <Dropdown
              clearable={true}
              id="CardDrugOrderQueueUX-Dropdown-19"
              onChange={props.changeSetDrugOrder("selectedDivision")}
              options={props.divisionOptions}
              search={true}
              selection={true}
              value={props.selectedDivision}>
            </Dropdown>
          </div>
          <div
            id="CardDrugOrderQueueUX-div-20"
            style={{display: "flex", alignItems: "center", marginRight: "10px"}}>

            <div
              id="CardDrugOrderQueueUX-div-21"
              style={{marginRight: "5px", width: "100px",textAlign: "right"}}>
              {props.languageUX === "en" ? "Order Type" : "ประเภทคำสั่งซื้อ"}
            </div>
            <Dropdown
              clearable={true}
              id="CardDrugOrderQueueUX-Dropdown-22"
              multiple={true}
              onChange={props.changeSetDrugOrder("selectedDrugOrderType")}
              options={props.drugOrderType}
              search={true}
              selection={true}
              value={props.selectedDrugOrderType}>
            </Dropdown>
          </div>
          <div
            id="CardDrugOrderQueueUX-div-11"
            style={{flex: 1}}>

          </div>
          <Button
            color="green"
            id="CardDrugOrderQueueUX-Button-13"
            size="tiny">
            {props.languageUX === "en" ? "Print prescription form" : "พิมพ์ใบจัดยา"}
          </Button>
          <Button
            color="green"
            id="CardDrugOrderQueueUX-Button-14"
            size="tiny">
            {props.languageUX === "en" ? "Print the medicine delivery sheet" : "พิมพ์ใบเตรียมจัดส่งยา"}
          </Button>
        </div>
        <div
          id="CardDrugOrderQueueUX-div-33"
          style={{display: props.hidePanel ? "none" : "none", alignItems: "center", padding: "10px 0px"}}>

          <div
            id="CardDrugOrderQueueUX-div-34"
            style={{marginRight: "5px", width: "80px",textAlign: "right"}}>
            {props.languageUX === "en" ? "Order Status" : "สถานะการสั่งซื้อ"}
          </div>
          <Dropdown
            clearable={true}
            id="CardDrugOrderQueueUX-Dropdown-36"
            multiple={true}
            onChange={props.changeSetDrugOrder("selectedDrugOrderStatus")}
            options={props.orderStatusOptions}
            search={true}
            selection={true}
            style={{width: "200px"}}
            value={props.selectedDrugOrderStatus}>
          </Dropdown>
          <div
            id="CardDrugOrderQueueUX-div-35"
            style={{margin: "0px 5px",width: "130px",textAlign: "right"}}>
            {props.languageUX === "en" ? "Shipper" : "ผู้ส่งสินค้า"}
          </div>
          <Dropdown
            clearable={true}
            id="CardDrugOrderQueueUX-Dropdown-37"
            onChange={props.changeSetDrugOrder("selectedShipper")}
            options={props.shipperOptions}
            search={true}
            selection={true}
            value={props.selectedShipper}>
          </Dropdown>
          <div
            id="CardDrugOrderQueueUX-div-38"
            style={{display: "flex", alignItems: "center", margin: "0px 10px"}}>

            <Checkbox
              checked={props.checkedOPD}
              id="CardDrugOrderQueueUX-Checkbox-39"
              onChange={props.changeSetDrugOrderCheck("checkedOPD")}>
            </Checkbox>
            <div
              id="CardDrugOrderQueueUX-div-40"
              style={{margin: "0 5px 0 5px"}}>
              {props.languageUX === "en" ? "OPD" : "OPD"}
            </div>
            <Checkbox
              checked={props.checkedIPD}
              id="CardDrugOrderQueueUX-Checkbox-41"
              onChange={props.changeSetDrugOrderCheck("checkedIPD")}>
            </Checkbox>
            <div
              id="CardDrugOrderQueueUX-div-42"
              style={{margin: "0 5px 0 5px"}}>
              {props.languageUX === "en" ? "IPD" : "IPD"}
            </div>
          </div>
          <Button
            color="blue"
            id="CardDrugOrderQueueUX-Button-43"
            loading={props.searching}
            onClick={props.onSearch}
            size="tiny">
            {props.languageUX === "en" ? "Search" : "ค้นหา"}
          </Button>
        </div>
        <Table
          className="--rt-tbody-overflow-y-hidden"
          data={props.drugOrderQueue}
          getTrProps={props.rowProps}
          headers={props.drugOrderQueueHeaders ? props.drugOrderQueueHeaders : ",Order No.,Status,Encounter Type,Order Type,HN,Patient name,Order by,Department,Order date/time,Shipper,Tracking No."}
          id="tb-medOrderQueueList"
          keys={`${props.hidePanel? "": "checkbox,"}code,status,encounter_type,type,hn,patientName, order_by_name, order_div_name,requested,prescription,shipping_company,tracking_number`}
          minRows={6}
          showPagination={false}
          style={{ height: props?.height || "80vh", display: props.isVerbal ? "none" : "flex", alignItems: "center", marginTop: "1rem"}}
          widths={`${props.hidePanel? "": "^40,"}150,^120,^90,^110,^80,^130,^130,^120,^110,^70,^70`}>
        </Table>
        <div
          id="CardDrugOrderQueueUX-div-140">
          {props.searchVerbal}
        </div>
        <Table
          data={props.verbalOrderQueue}
          getTrProps={props.verbalRowProps}
          headers="ชื่อนามสกุล,เลขที่,division,ประเภท,VN/AN,วันเวลา"
          id="CardDrugOrderQueueUX-Table-31"
          keys="patient_name,drug_order_code,division,drug_order_type,en,edited"
          showPagination={false}
          style={{height: props?.height || "80vh", display: props.isVerbal ? "flex":"none", alignItems: "center"}}>
        </Table>
      </div>
    )
}


export default CardDrugOrderQueueUX

export const screenPropsDefault = {"height":"40vh","language":"TH","patientSearch":"[Patient Search Box]"}

/* Date Time : Fri Sep 25 2026 15:46:19 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueue"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\",padding: \"5px\" }"
        }
      },
      "seq": 0
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 8,
      "name": "Table",
      "parent": 0,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "data": {
          "type": "code",
          "value": "props.drugOrderQueue"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.rowProps"
        },
        "headers": {
          "type": "code",
          "value": "props.drugOrderQueueHeaders ? props.drugOrderQueueHeaders : \",Order No.,Status,Encounter Type,Order Type,HN,Patient name,Order by,Department,Order date/time,Shipper,Tracking No.\""
        },
        "id": {
          "type": "value",
          "value": "tb-medOrderQueueList"
        },
        "keys": {
          "type": "code",
          "value": "`${props.hidePanel? \"\": \"checkbox,\"}code,status,encounter_type,type,hn,patientName, order_by_name, order_div_name,requested,prescription,shipping_company,tracking_number`"
        },
        "minRows": {
          "type": "code",
          "value": "6"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{ height: props?.height || \"80vh\", display: props.isVerbal ? \"none\" : \"flex\", alignItems: \"center\", marginTop: \"1rem\"}"
        },
        "widths": {
          "type": "code",
          "value": "`${props.hidePanel? \"\": \"^40,\"}150,^120,^90,^110,^80,^130,^130,^120,^110,^70,^70`"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-div-9"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", padding: \"5px\", margin: \"0.5rem 0 0.75rem\", justifyContent: \"space-between\", alignItems: \"center\",}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-div-10"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-div-11"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1}"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "Button",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": "พิมพ์ใบจัดยา",
          "valueEN": "Print prescription form"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-Button-13"
        },
        "size": {
          "type": "value",
          "value": "tiny"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "Button",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": "พิมพ์ใบเตรียมจัดส่งยา",
          "valueEN": "Print the medicine delivery sheet"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-Button-14"
        },
        "onClick": {
          "type": "code",
          "value": ""
        },
        "size": {
          "type": "value",
          "value": "tiny"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-div-15"
        },
        "style": {
          "type": "code",
          "value": "{display: props.hidePanel ? \"none\" : \"none\", alignItems: \"center\"}"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientSearch"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-div-16"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"5px\", width: \"230px\"}"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-div-17"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", marginRight: \"10px\"}"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 17,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนก/หอผู้ป่วย",
          "valueEN": "Division/Ward"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-div-18"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"5px\", width: \"100px\",textAlign: \"right\"}"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 19,
      "name": "Dropdown",
      "parent": 17,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-Dropdown-19"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeSetDrugOrder(\"selectedDivision\")"
        },
        "options": {
          "type": "code",
          "value": "props.divisionOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.selectedDivision"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-div-20"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", marginRight: \"10px\"}"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "div",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทคำสั่งซื้อ",
          "valueEN": "Order Type"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-div-21"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"5px\", width: \"100px\",textAlign: \"right\"}"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "Dropdown",
      "parent": 20,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-Dropdown-22"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeSetDrugOrder(\"selectedDrugOrderType\")"
        },
        "options": {
          "type": "code",
          "value": "props.drugOrderType"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.selectedDrugOrderType"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 31,
      "name": "Table",
      "parent": 0,
      "props": {
        "data": {
          "type": "code",
          "value": "props.verbalOrderQueue"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.verbalRowProps"
        },
        "headers": {
          "type": "value",
          "value": "ชื่อนามสกุล,เลขที่,division,ประเภท,VN/AN,วันเวลา"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-Table-31"
        },
        "keys": {
          "type": "value",
          "value": "patient_name,drug_order_code,division,drug_order_type,en,edited"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: props?.height || \"80vh\", display: props.isVerbal ? \"flex\":\"none\", alignItems: \"center\"}"
        }
      },
      "seq": 140,
      "void": false
    },
    {
      "from": null,
      "id": 32,
      "name": "label",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ป่วย",
          "valueEN": "Patient"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-label-32"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"10px\", width: \"80px\",textAlign: \"right\"}"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 33,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-div-33"
        },
        "style": {
          "type": "code",
          "value": "{display: props.hidePanel ? \"none\" : \"none\", alignItems: \"center\", padding: \"10px 0px\"}"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": null,
      "id": 34,
      "name": "div",
      "parent": 33,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะการสั่งซื้อ",
          "valueEN": "Order Status"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-div-34"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"5px\", width: \"80px\",textAlign: \"right\"}"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": null,
      "id": 35,
      "name": "div",
      "parent": 33,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ส่งสินค้า",
          "valueEN": "Shipper"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-div-35"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 5px\",width: \"130px\",textAlign: \"right\"}"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 36,
      "name": "Dropdown",
      "parent": 33,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-Dropdown-36"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeSetDrugOrder(\"selectedDrugOrderStatus\")"
        },
        "options": {
          "type": "code",
          "value": "props.orderStatusOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"200px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.selectedDrugOrderStatus"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "Dropdown",
      "parent": 33,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-Dropdown-37"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeSetDrugOrder(\"selectedShipper\")"
        },
        "options": {
          "type": "code",
          "value": "props.shipperOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.selectedShipper"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "name": "div",
      "parent": 33,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-div-38"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"0px 10px\"}"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 39,
      "name": "Checkbox",
      "parent": 38,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.checkedOPD"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-Checkbox-39"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeSetDrugOrderCheck(\"checkedOPD\")"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "div",
      "parent": 38,
      "props": {
        "children": {
          "type": "value",
          "value": "OPD",
          "valueEN": "OPD"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-div-40"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0 5px 0 5px\"}"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 41,
      "name": "Checkbox",
      "parent": 38,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.checkedIPD"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-Checkbox-41"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeSetDrugOrderCheck(\"checkedIPD\")"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "div",
      "parent": 38,
      "props": {
        "children": {
          "type": "value",
          "value": "IPD",
          "valueEN": "IPD"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-div-42"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0 5px 0 5px\"}"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "Button",
      "parent": 33,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหา",
          "valueEN": "Search"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-Button-43"
        },
        "loading": {
          "type": "code",
          "value": "props.searching"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSearch"
        },
        "size": {
          "type": "value",
          "value": "tiny"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": null,
      "id": 44,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-div-44"
        },
        "style": {
          "type": "code",
          "value": "{display: props.hidePanel ? \"none\" : \"\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 45,
      "name": "FormGroup",
      "parent": 44,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-FormGroup-45"
        },
        "inline": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 46,
      "name": "FormGroup",
      "parent": 44,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-FormGroup-46"
        },
        "inline": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 48,
      "name": "FormField",
      "parent": 45,
      "props": {
        "className": {
          "type": "value",
          "value": " --override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-FormField-48"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 49,
      "name": "FormField",
      "parent": 45,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-FormField-49"
        },
        "inline": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 50,
      "name": "FormField",
      "parent": 45,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-FormField-50"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "div",
      "parent": 48,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientSearch"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-div-53"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 148,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "Checkbox",
      "parent": 49,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.checkedOPD"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-Checkbox-54"
        },
        "label": {
          "type": "value",
          "value": "ผู้ป่วยนอก",
          "valueEN": "OPD"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeSetDrugOrderCheck(\"checkedOPD\")"
        },
        "style": {
          "type": "code",
          "value": "{height: \"100%\", display: \"flex\", alignItems: \"center\", marginTop: \"-0.75rem\"}"
        }
      },
      "seq": 122,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 55,
      "name": "Checkbox",
      "parent": 50,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.checkedIPD"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-Checkbox-55"
        },
        "label": {
          "type": "value",
          "value": "ผู้ป่วยใน",
          "valueEN": "IPD"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeSetDrugOrderCheck(\"checkedIPD\")"
        },
        "style": {
          "type": "code",
          "value": "{height: \"100%\", display: \"flex\", alignItems: \"center\", marginTop: \"-0.75rem\"}"
        }
      },
      "seq": 123,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 62,
      "name": "FormField",
      "parent": 45,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-FormField-62"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 63,
      "name": "FormField",
      "parent": 45,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-FormField-63"
        },
        "inline": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": null,
      "id": 66,
      "name": "label",
      "parent": 63,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง",
          "valueEN": "to"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-label-66"
        },
        "style": {
          "type": "code",
          "value": "{height: \"100%\", display: \"flex\", alignItems: \"center\", marginTop: \"-0.75rem\"}"
        }
      },
      "seq": 126,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 67,
      "name": "FormField",
      "parent": 45,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-FormField-67"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": null,
      "id": 69,
      "name": "div",
      "parent": 62,
      "props": {
        "children": {
          "type": "code",
          "value": "props.StartDate"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-div-69"
        },
        "style": {
          "type": "code",
          "value": "{minWidth:\"100%\", width: 0}"
        }
      },
      "seq": 138,
      "void": false
    },
    {
      "from": null,
      "id": 70,
      "name": "div",
      "parent": 67,
      "props": {
        "children": {
          "type": "code",
          "value": "props.EndDate"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-div-70"
        },
        "style": {
          "type": "code",
          "value": "{minWidth:\"100%\", width: 0}"
        }
      },
      "seq": 127,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 81,
      "name": "FormField",
      "parent": 46,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-FormField-81"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "props.hideSort ? 6: 5"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": null,
      "id": 82,
      "name": "div",
      "parent": 81,
      "props": {
        "children": {
          "type": "code",
          "value": "props.OrderStatus"
        },
        "id": {
          "type": "value",
          "value": "cb-medOrderStatus"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 130,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 87,
      "name": "FormField",
      "parent": 46,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-FormField-87"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "props.hideSort ? 8 : 7"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": null,
      "id": 88,
      "name": "div",
      "parent": 87,
      "props": {
        "children": {
          "type": "code",
          "value": "props.OrderType"
        },
        "id": {
          "type": "value",
          "value": "cb-medOrderType"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 134,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 89,
      "name": "FormField",
      "parent": 45,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-FormField-89"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ minWidth: \"max-content\"}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 90,
      "name": "Checkbox",
      "parent": 89,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.checkedContinue"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-Checkbox-90"
        },
        "label": {
          "type": "value",
          "value": "Continue for Day dose",
          "valueEN": "Continue for Day dose"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeSetDrugOrderCheck(\"checkedContinue\")"
        },
        "style": {
          "type": "code",
          "value": "{height: \"100%\", display: \"flex\", alignItems: \"center\", marginTop: \"-0.75rem\", minWidth: \"max-content\"}"
        }
      },
      "seq": 124,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 92,
      "name": "FormField",
      "parent": 46,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-FormField-92"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 94,
      "name": "Dropdown",
      "parent": 92,
      "props": {
        "clearable": {
          "type": "code",
          "value": ""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-Dropdown-94"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeSetDrugOrder(\"selectedLocation\")"
        },
        "options": {
          "type": "code",
          "value": "props.divisionTypeDrugOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.selectedLocation"
        }
      },
      "seq": 129,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 95,
      "name": "FormField",
      "parent": 45,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-FormField-95"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 96,
      "name": "Dropdown",
      "parent": 95,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-Dropdown-96"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeSetDrugOrder(\"selectedDivision\")"
        },
        "options": {
          "type": "code",
          "value": "props.divisionOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth:\"100%\", width: 0}"
        },
        "value": {
          "type": "code",
          "value": "props.selectedDivision"
        }
      },
      "seq": 125,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 97,
      "name": "FormField",
      "parent": 46,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-FormField-97"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 119,
      "name": "FormField",
      "parent": 45,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-FormField-119"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 117,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 120,
      "name": "Dropdown",
      "parent": 119,
      "props": {
        "clearable": {
          "type": "code",
          "value": ""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-Dropdown-120"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeSetDrugOrder(\"selectedApprove\")"
        },
        "options": {
          "type": "code",
          "value": "props.approveOption"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth:\"100%\", width: 0}"
        },
        "value": {
          "type": "code",
          "value": "props.selectedApprove"
        }
      },
      "seq": 128,
      "void": false
    },
    {
      "from": null,
      "id": 122,
      "name": "label",
      "parent": 49,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-label-122"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": null,
      "id": 123,
      "name": "label",
      "parent": 50,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-label-123"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": null,
      "id": 124,
      "name": "label",
      "parent": 89,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-label-124"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": null,
      "id": 125,
      "name": "label",
      "parent": 95,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนก/หอผู้ป่วย",
          "valueEN": "Division/Ward"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-label-125"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": null,
      "id": 126,
      "name": "label",
      "parent": 63,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-label-126"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": null,
      "id": 127,
      "name": "label",
      "parent": 67,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-label-127"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": null,
      "id": 128,
      "name": "label",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": "Approve order "
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-label-128"
        }
      },
      "seq": 120,
      "void": false
    },
    {
      "from": null,
      "id": 129,
      "name": "label",
      "parent": 92,
      "props": {
        "children": {
          "type": "value",
          "value": "ที่ตั้ง",
          "valueEN": "Location"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-label-129"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": null,
      "id": 130,
      "name": "div",
      "parent": 81,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-div-130"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\", marginBottom: \".28571429rem\"}"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": null,
      "id": 131,
      "name": "label",
      "parent": 130,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะคำสั่ง",
          "valueEN": "Order Status"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-label-131"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: 700, color: \"rgba(0,0,0,.87)\", fontSize: \".92857143em\"}"
        }
      },
      "seq": 131,
      "void": false
    },
    {
      "from": null,
      "id": 132,
      "name": "div",
      "parent": 130,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-div-132"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"0.5rem\"}"
        }
      },
      "seq": 132,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 133,
      "name": "Icon",
      "parent": 132,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-Icon-133"
        },
        "link": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "undo"
        },
        "onClick": {
          "type": "code",
          "value": "props.onResetFilter(\"selectedDrugOrderStatus\")"
        }
      },
      "seq": 133,
      "void": false
    },
    {
      "from": null,
      "id": 134,
      "name": "div",
      "parent": 87,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-div-134"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\", marginBottom: \".28571429rem\"}"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": null,
      "id": 135,
      "name": "label",
      "parent": 134,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทคำสั่ง",
          "valueEN": "Order Type"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-label-135"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: 700, color: \"rgba(0,0,0,.87)\", fontSize: \".92857143em\"}"
        }
      },
      "seq": 135,
      "void": false
    },
    {
      "from": null,
      "id": 136,
      "name": "div",
      "parent": 134,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-div-136"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"0.5rem\"}"
        }
      },
      "seq": 136,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 137,
      "name": "Icon",
      "parent": 136,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-Icon-137"
        },
        "link": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "undo"
        },
        "onClick": {
          "type": "code",
          "value": "props.onResetFilter(\"selectedDrugOrderType\")"
        }
      },
      "seq": 137,
      "void": false
    },
    {
      "from": null,
      "id": 138,
      "name": "label",
      "parent": 62,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่สร้าง",
          "valueEN": "Created date"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-label-138"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": null,
      "id": 139,
      "name": "label",
      "parent": 97,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-label-139"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": null,
      "id": 140,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.searchVerbal"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-div-140"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": null,
      "id": 141,
      "name": "div",
      "parent": 97,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ButtonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-div-141"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"6px\"}"
        }
      },
      "seq": 141,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 143,
      "name": "FormField",
      "parent": 46,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-FormField-143"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: props.hideSort ? \"none\" : \"\" }"
        },
        "width": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 143,
      "void": false
    },
    {
      "from": null,
      "id": 147,
      "name": "label",
      "parent": 143,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-label-147"
        }
      },
      "seq": 146,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 148,
      "name": "FormField",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-FormField-148"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", alignItems: \"center\"}"
        }
      },
      "seq": 121,
      "void": false
    },
    {
      "from": null,
      "id": 149,
      "name": "label",
      "parent": 148,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ป่วย",
          "valueEN": "Patient"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-label-149"
        }
      },
      "seq": 149,
      "void": false
    },
    {
      "from": null,
      "id": 150,
      "name": "div",
      "parent": 148,
      "props": {
        "children": {
          "type": "code",
          "value": "props.clearFilterPatient"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-div-150"
        }
      },
      "seq": 150,
      "void": false
    },
    {
      "from": null,
      "id": 151,
      "name": "div",
      "parent": 143,
      "props": {
        "children": {
          "type": "code",
          "value": "props.dropdownSort"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-div-151"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", marginTop: \"0.45rem\", fontSize: \"0.95rem\"}"
        }
      },
      "seq": 151,
      "void": false
    },
    {
      "from": null,
      "id": 152,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-div-152"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\" }"
        }
      },
      "seq": 152,
      "void": false
    },
    {
      "from": null,
      "id": 153,
      "name": "div",
      "parent": 152,
      "props": {
        "children": {
          "type": "code",
          "value": "props.refillPlaned"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-div-153"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.showDrugOrderPendingList ? \"flex\" : \"none\" }"
        }
      },
      "seq": 153,
      "void": false
    },
    {
      "from": null,
      "id": 154,
      "name": "div",
      "parent": 152,
      "props": {
        "children": {
          "type": "code",
          "value": "props.countdownTimer"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-div-154"
        },
        "style": {
          "type": "code",
          "value": "{ marginLeft: \"20px\" ,display: props.hidePanel ? \"none\" : \"\"}"
        }
      },
      "seq": 154,
      "void": false
    },
    {
      "from": null,
      "id": 155,
      "name": "div",
      "parent": 10,
      "props": {
        "children": {
          "type": "code",
          "value": "props.isVerbal ? \"รายการรับคำสั่งแพทย์\" : \"รายการใบยา\""
        },
        "className": {
          "type": "value",
          "value": "",
          "valueEN": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-div-155"
        },
        "style": {
          "type": "code",
          "value": "{ fontSize: \"1.5rem\", fontWeight: \"bold\",  marginTop: \"-2px\"}"
        }
      },
      "seq": 155,
      "void": false
    },
    {
      "from": null,
      "id": 156,
      "name": "label",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": "สแกนบาร์โค้ด",
          "valueEN": "Barcode scan"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-label-156"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0 1rem 0 2rem\"}"
        }
      },
      "seq": 156,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 157,
      "name": "Input",
      "parent": 10,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderQueueUX-Input-157"
        },
        "loading": {
          "type": "code",
          "value": "props.barcodeLoading"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeBarcode"
        },
        "onKeyDown": {
          "type": "code",
          "value": "props.onKeyDownBarcode"
        },
        "placeholder": {
          "type": "value",
          "value": "Prescription, Label"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{width: \"12rem\"}"
        },
        "value": {
          "type": "code",
          "value": "props.barcodeScan || \"\""
        }
      },
      "seq": 157,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 90,
  "isMounted": false,
  "memo": false,
  "name": "CardDrugOrderQueueUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "height": "40vh",
    "language": "TH",
    "patientSearch": "[Patient Search Box]"
  },
  "width": 80
}

*********************************************************************************** */
